import React from 'react';
import styles from './datePicker.module.scss';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disablePast?: boolean;
  useDialog?: boolean;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  className = '',
  disablePast = false,
  useDialog = false,
}) => {
  return (
    <div className={`${styles.datePickerGroup} ${className}`}>
      <label className={styles.label}>{label}</label>
      <DateTimePicker
        disablePast={disablePast}
        format="DD/MM/YYYY HH:mm"
        desktopModeMediaQuery={
          useDialog ? '@media (pointer: fine) and (min-width: 9999px)' : '@media (pointer: fine)'
        }
        value={value ? dayjs(value) : null}
        onChange={(newValue: Dayjs | null) => {
          if (newValue) {
            onChange(newValue.toISOString());
          } else {
            onChange('');
          }
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            sx: {
              '& .MuiInputBase-root': {
                background: 'transparent',
                borderRadius: '10px',
                '& fieldset': { border: 'none' },
                '&:hover fieldset': { border: 'none' },
                '&.Mui-focused fieldset': { border: 'none' },
              },
              '& .MuiInputBase-input': {
                padding: '12px 16px',
                fontSize: '14px',
                color: 'var(--text-primary)',
              },
              '& .MuiPickersInputBase-root': {
                color: 'var(--text-primary)',
                border: '1px solid var(--border-color)',
              },
              '& .MuiSvgIcon-root': {
                color: 'var(--text-secondary)',
              },
            },
          },
        }}
      />
    </div>
  );
};

export default DatePicker;
